<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'CUESTIONARIO.LBL_CUESTIONARIO' | translate}}" *ngIf="cuestionario">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIO.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-3 md:col-4 "><strong>{{cuestionario.codigo}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIO.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-9 col-6 md:col-8"><strong>{{cuestionario.nombre}}</strong></label>
        </div>
        <div class="grid">
          <label class="cuadrovisualizar lg:col-3 col-6 md:col-4 control-label"><strong>{{ 'CUESTIONARIO.LBL_COMPORTAMIENTOPREGUNTAS' | translate }}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIO.LBL_ALAZAR' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{cuestionario.indicadorAzar ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIO.LBL_NUMEROPREGUNTAS' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{cuestionario.numeroPreguntas}}</strong></label>
        </div>
        <div class="grid">
          <label class="cuadrovisualizar lg:col-3 col-6 md:col-4 control-label"><strong>{{ 'CUESTIONARIO.LBL_PORCENTAJEAPROBACION' | translate }}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIO.LBL_REQPONDERACION' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{cuestionario.indicadorPonderacion ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIO.LBL_VALOR' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{cuestionario.valorPonderacion}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_SARLAFT4.0' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{cuestionario.indicadorSarlaft4 ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{cuestionario.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIO.LBL_DESCRIPCION' | translate }}:</label>
          <label class="lg:col-9 col-6 md:col-8 "><strong>{{cuestionario.descripcion}}</strong></label>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'CUESTIONARIO.LBL_PREGUNTAS' | translate}}">
        <p-table [columns]="columnas"
                 [value]="cuePreguntas" selectionMode="single" dataKey="idCuestionarioPregunta"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.pregunta}}</td>
              <td>{{row.tipoPregunta}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
              <td class="text-center">
                <div class="btn-group" role="group">
                  <button type="button" class="p-button btn" icon="fa fa-eye" data-toggle="tooltip"
                          title="{{'BTN_VISUALIZAR' | translate}}" pButton
                          (click)="ver(row)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>
<p-dialog [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [(visible)]="mosPregunta"
          header="{{ 'CUESTIONARIO.LBL_PREGUNTA'  | translate}} : {{preSeleccionada ? preSeleccionada.pregunta : ''}}"
          [modal]="true">
  <div *ngIf="preSeleccionada">
    <div class="grid">
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIOPREGUNTA.LBL_TIPO' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8 "><strong>{{preSeleccionada.tipoPregunta}}</strong></label>
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIO.LBL_PREGUNTA' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8"><strong>{{preSeleccionada.pregunta}}</strong></label>
    </div>
    <div class="grid">
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CUESTIONARIOPREGUNTA.LBL_FILTRANTE' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8"><strong>{{preSeleccionada.indicadorDescartante ? ('LBL_SI' | translate) : ('LBL_NO' |
        translate)}}</strong></label>
      <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
      <label class="lg:col-3 col-6 md:col-8"><strong>{{preSeleccionada.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
        translate)}}</strong></label>
    </div>
    <div class="grid">
      <div class="col-12 lg:col-12 md:col-12">
        <p-table [columns]="colRespuestas"
                 [value]="preSeleccionada.respuestas" selectionMode="single" dataKey="idCuestionarioPreguntaRespuesta"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.respuesta}}</td>
              <td>{{row.preguntaDepende}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorCorrecta" binary="true" disabled="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-close" label="{{ 'BTN_CERRAR' | translate }}" type="button"
                pButton (click)="cerrar()"></button>
      </div>
    </div>
  </div>
</p-dialog>
